function bookingsWithoutStaff(eventBookings) {
  return eventBookings.filter(booking => {
    const assignedStaffIds = booking.attributes.staffMemberIds
    return !assignedStaffIds || assignedStaffIds.length === 0
  })
}

export default bookingsWithoutStaff
